"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.copyJobInfo = copyJobInfo;
exports.copyWorkflow = copyWorkflow;
exports.deleteWorkflow = deleteWorkflow;
exports.downloadInstanceLog = downloadInstanceLog;
exports.getApp = getApp;
exports.getWorker = getWorker;
exports.getWorkflow = getWorkflow;
exports.getWorkflowInstance = getWorkflowInstance;
exports.markNodeAsSuccess = markNodeAsSuccess;
exports.queryInstanceDetail = queryInstanceDetail;
exports.queryInstanceLog = queryInstanceLog;
exports.queryJobInfo = queryJobInfo;
exports.queryTaskInstance = queryTaskInstance;
exports.queryTimeExpression = queryTimeExpression;
exports.queryUserList = queryUserList;
exports.queryWorkflowInfo = queryWorkflowInfo;
exports.queryWorkflowInstance = queryWorkflowInstance;
exports.retryInstance = retryInstance;
exports.retryWorkflowInstance = retryWorkflowInstance;
exports.runJobInfo = runJobInfo;
exports.runWorkflow = runWorkflow;
exports.saveJobInfo = saveJobInfo;
exports.saveUser = saveUser;
exports.saveWorkflow = saveWorkflow;
exports.saveWorkflowNode = saveWorkflowNode;
exports.stopInstance = stopInstance;
exports.stopWorkflowInstance = stopWorkflowInstance;
exports.switchJobInfo = switchJobInfo;
exports.switchWorkflow = switchWorkflow;
var _axios = _interopRequireDefault(require("axios"));
var request = _axios.default.create({
  baseURL: process.env.VUE_APP_POWERJOB_API,
  timeout: 5000
});
function getApp(query) {
  return request({
    url: '/system/overview',
    method: 'get',
    params: query
  });
}
function getWorker(query) {
  return request({
    url: '/system/listWorker',
    method: 'get',
    params: query
  });
}
function queryJobInfo(data) {
  return request({
    url: '/job/list',
    method: 'post',
    data: data
  });
}
function queryUserList() {
  return request({
    url: '/user/list',
    method: 'get'
  });
}
function queryTimeExpression(query) {
  return request({
    url: '/validate/timeExpression',
    method: 'get',
    params: query
  });
}
function switchJobInfo(data) {
  return request({
    url: '/job/disable',
    method: 'get',
    params: {
      jobId: data
    }
  });
}
function saveJobInfo(data) {
  return request({
    url: '/job/save',
    method: 'post',
    data: data
  });
}
function saveUser(data) {
  return request({
    url: '/user/save',
    method: 'post',
    data: data
  });
}
function copyJobInfo(data) {
  return request({
    url: '/job/copy',
    method: 'post',
    params: {
      jobId: data
    }
  });
}
function runJobInfo(query) {
  return request({
    url: '/job/run',
    method: 'get',
    params: query
  });
}

// export function deleteJobInfo(data) {
//   return request({
//     url: '/job/delete',
//     method: 'get',
//     params: {
//       jobId: data
//     }
//   })
// }

function queryTaskInstance(data) {
  return request({
    url: '/instance/list',
    method: 'post',
    data: data
  });
}
function queryInstanceDetail(query) {
  return request({
    url: '/instance/detail',
    method: 'get',
    params: query
  });
}
function queryInstanceLog(query) {
  return request({
    url: '/instance/log',
    method: 'get',
    params: query
  });
}
function downloadInstanceLog(query) {
  return request({
    url: '/instance/downloadLogUrl',
    method: 'get',
    params: query
  });
}
function retryInstance(query) {
  return request({
    url: '/instance/retry',
    method: 'get',
    params: query
  });
}
function stopInstance(query) {
  return request({
    url: '/instance/stop',
    method: 'get',
    params: query
  });
}
function queryWorkflowInfo(data) {
  return request({
    url: '/workflow/list',
    method: 'post',
    data: data
  });
}
function switchWorkflow(data) {
  return request({
    url: '/workflow/' + data.path,
    method: 'get',
    params: {
      appId: data.appId,
      workflowId: data.workflowId
    }
  });
}
function runWorkflow(query) {
  return request({
    url: '/workflow/run',
    method: 'get',
    params: query
  });
}
function getWorkflow(data) {
  return request({
    url: '/workflow/fetch',
    method: 'get',
    params: {
      appId: data.appId,
      workflowId: data.workflowId
    }
  });
}
function saveWorkflow(data) {
  return request({
    url: '/workflow/save',
    method: 'post',
    data: data
  });
}
function saveWorkflowNode(data) {
  return request({
    url: '/workflow/saveNode',
    method: 'post',
    data: data
  });
}
function deleteWorkflow(data) {
  return request({
    url: '/workflow/delete',
    method: 'get',
    params: {
      appId: data.appId,
      workflowId: data.workflowId
    }
  });
}
function copyWorkflow(data) {
  return request({
    url: '/workflow/copy',
    method: 'post',
    params: {
      appId: data.appId,
      workflowId: data.workflowId
    }
  });
}
function queryWorkflowInstance(data) {
  return request({
    url: '/wfInstance/list',
    method: 'post',
    data: data
  });
}
function retryWorkflowInstance(query) {
  return request({
    url: '/wfInstance/retry',
    method: 'get',
    params: query
  });
}
function stopWorkflowInstance(query) {
  return request({
    url: '/wfInstance/stop',
    method: 'get',
    params: query
  });
}
function getWorkflowInstance(query) {
  return request({
    url: '/wfInstance/info',
    method: 'get',
    params: query
  });
}
function markNodeAsSuccess(data) {
  return request({
    url: '/wfInstance/markNodeAsSuccess',
    method: 'get',
    params: data
  });
}